import { createContext, useContext } from 'react';

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */
function createCtx<A extends Record<string, unknown> | [unknown, unknown] | null>() {
	const context = createContext<A | undefined>(undefined);
	function useCtx() {
		const contextInstance = useContext(context);
		if (contextInstance === undefined)
			throw new Error('useCtx must be inside a Provider with a value');

		return contextInstance;
	}

	return [useCtx, context.Provider] as const; // 'as const' makes TypeScript infer a tuple
}

export { createCtx };
